import React from 'react';
import ReactDOM from 'react-dom/client';
import 'styles/index.scss';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from 'store';
import Router from 'routes/Router';
import { ErrorBoundary } from 'components';
import { useNavigatorOnLine } from 'hooks';
import { OfflinePage } from 'pages';
import packageJson from '../package.json';

console.log(
	`%cWelcome to Ripplr LogiTrack - ${process.env.NODE_ENV} - ${process.env.REACT_APP_ENV} - ${packageJson.version}`,
	'background: #46C2B6; color: #113F5F; font-size: 12px'
);

function AppRender() {
	const networkStatus = useNavigatorOnLine();
	return (
		<ErrorBoundary>
			<Provider store={store}>
				{networkStatus ? (
					<BrowserRouter basename={process.env.PUBLIC_URL}>
						<Router />
					</BrowserRouter>
				) : (
					<OfflinePage />
				)}
			</Provider>
		</ErrorBoundary>
	);
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<AppRender />);

if ('serviceWorker' in navigator) {
	navigator.serviceWorker
		.register('/firebase-messaging-sw.js')
		.then((registration) => {
			console.debug('Firebase SW registered:', registration);
		})
		.catch((err) => {
			console.debug('SW registration failed:', err);
		});
}
